import * as React from "react";
import { useTranslation } from "react-i18next";
import ActionDropdown from "views/components/common/ActionDropdown";
import IconButton from "components/common/IconButton";
const QueryActionDropdown = ({ children }) => {
  const { t } = useTranslation("search");
  return /* @__PURE__ */ React.createElement(
    ActionDropdown,
    {
      element: /* @__PURE__ */ React.createElement(
        IconButton,
        {
          name: "arrow_drop_down",
          "data-testid": "query-action-dropdown",
          title: t("query_title.page_actions"),
          showTooltip: false
        }
      )
    },
    children
  );
};
export default QueryActionDropdown;
